import './partners.component.scss'
// import './partners.component.pug'

import { Application } from '../../helpers/app'
const autoplay = {
  delay: 3000,
  disableOnInteraction: false
}

Application.swiper().then(({ Swiper }) => {
  new Swiper('.partners-slider', {
    slidesPerView: 1,
    spaceBetween: 64,
    autoplay: autoplay,
    loop: true,
    breakpoints: {
      992: {
        slidesPerView: 5
      },
      768: {
        slidesPerView: 4
      },
      555: {
        slidesPerView: 3
      },
      480: {
        slidesPerView: 2
      }
    }
  })
  Application.lozad('.partners-slider .lozad')
})
